<main appUniversalResources>
  <pixie-homepage [class]="pixieHomepageClassList"></pixie-homepage>
</main>
<font-icon-loader></font-icon-loader>
